"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_string_exports = {};
__export(query_string_exports, {
  generateQueryString: () => generateQueryString
});
module.exports = __toCommonJS(query_string_exports);
var import_url = require("url");
function generateQueryString(clientOptions) {
  const options = new import_url.URLSearchParams();
  if (clientOptions.teamId) {
    options.set("teamId", clientOptions.teamId);
  }
  if (clientOptions.force) {
    options.set("forceNew", "1");
  }
  if (clientOptions.withCache) {
    options.set("withCache", "1");
  }
  if (clientOptions.skipAutoDetectionConfirmation) {
    options.set("skipAutoDetectionConfirmation", "1");
  }
  return Array.from(options.entries()).length ? `?${options.toString()}` : "";
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  generateQueryString
});
